import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/App";

export default function ClosingCta() {
  return (
    <section className="relative bg-[#221812] px-6 py-32 sm:px-12 sm:py-44 lg:px-20" data-testid="closing-cta-section">
      <div aria-hidden="true" className="absolute left-0 right-0 top-0 h-px bg-[#9A7B3F]/50" />
      <div aria-hidden="true" className="absolute left-0 right-0 top-2 h-px bg-[#9A7B3F]/20" />
      <div className="relative mx-auto max-w-6xl">
        <Reveal>
          <p className="font-code text-[11px] uppercase tracking-[0.4em] text-[#9A7B3F]">[ Final Call — 04 · 2027 ]</p>
        </Reveal>
        <Reveal delay={0.15}>
          <h2
            className="mt-10 max-w-4xl font-display text-4xl leading-[1.02] tracking-tight text-[#F4EEE3] sm:text-6xl lg:text-7xl"
            data-testid="closing-headline"
          >
            Your place in the pack <span className="italic text-[#C4A05C]">starts here.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-14 flex max-w-md flex-col gap-4 sm:max-w-none sm:flex-row">
            <button
              onClick={() => scrollToId("#waitlist")}
              className="bg-[#F4EEE3] px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#221812] transition-colors duration-300 hover:bg-[#5E1A22] hover:text-[#F4EEE3]"
              data-testid="closing-join-waitlist-btn"
            >
              Join the Free Waitlist
            </button>
            <button
              onClick={() => scrollToId("#apply")}
              className="border border-[#F4EEE3]/40 px-8 py-4 text-xs uppercase tracking-[0.25em] text-[#F4EEE3] transition-colors duration-300 hover:border-[#C4A05C] hover:text-[#C4A05C]"
              data-testid="closing-apply-custom-btn"
            >
              Apply for a Custom Piece
            </button>
          </div>
        </Reveal>
      </div>
      <div aria-hidden="true" className="absolute bottom-2 left-0 right-0 h-px bg-[#9A7B3F]/20" />
      <div aria-hidden="true" className="absolute bottom-0 left-0 right-0 h-px bg-[#9A7B3F]/50" />
    </section>
  );
}
